<template>
    <div>
        <div class="form-group row">
            <label class="col-form-label col-sm-3">{{translate('incomingDoc.address')}}:</label>
            <div class="col-sm-9">
                <input v-model="value.Address" name="Address" type="text" class="form-control"  />
            </div>
        </div>    
        <div class="form-group row">
            <label class="col-form-label col-sm-3">{{translate('incomingDoc.userId')}}:</label>
            <div class="col-sm-9">
                <input v-model="value.UserId" name="UserId" type="text" class="form-control"  />
            </div>
        </div>    
        <div class="form-group row">
            <label class="col-form-label col-sm-3">{{translate('incomingDoc.userIdentityNo')}}:</label>
            <div class="col-sm-9">
                <input v-model="value.IdentityNumber" name="IdentityNumber" type="number" class="form-control"  maxlength="11" />
            </div>
        </div>
         <div class="form-group row">
            <label class="col-form-label col-sm-3">{{translate('incomingDoc.userPassword')}}:</label>
            <div class="col-sm-9">
                <input v-model="value.Password" name="Password" type="password" class="form-control"  />
            </div>
        </div>
        <div class="form-group row">
            <label class="col-form-label col-sm-3">{{translate('incomingDoc.loginType')}}:</label>
            <div class="col-sm-9">
                <select class="form-control" v-model="value.LoginType" >
                    <option value="option1">option1</option>              
                    <option value="option2">option2</option>              
                </select>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    components: {
    },
    props: ['value'],
    data(){
        return {

        }
    },
    methods: {
    }
}

</script>